'use strict';

(function ($) {
    var methods = {
        init: function (options) {
            return this.each(function () {
                var _this = this;
                var $this = $(this);

                if ($this.hasClass('tac-init')) {
                    return;
                }
                
                options = $.extend({}, $.fn.tac.defaults, options || {});
                
                $this.addClass('tac-init');
                
                $this.find('.tac-text-scroll-wrapper').scrollbar().on('scroll', function () {
                    methods.scroll.apply(_this, [$(this)]);
                });
            });
        },

        scroll: function ($scrollbar) {
            if(($scrollbar.scrollTop() + $scrollbar.height()) >= ($scrollbar.find('.tac-text').outerHeight() - 20)) {
                $(this).removeClass('tac-warning');
                $(this).find('button[type="submit"]').removeAttr('disabled');
                $(this).find('input[name="tac"]').val(1);
                $(this).find('.submit-button-fake').remove();
                $(this).find('button[type="submit"]').text($(this).find('button[type="submit"]').data('btn_text'));
            }
        }
    };

    $.fn.tac = function (methodOrOptions) {
        if (methods[methodOrOptions]) {
            return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exists on jQuery.tac');
        }
    };

    $.fn.tac.defaults = {};
})(jQuery);
